import clsx from 'clsx'
import {FC} from 'react'

type Props = {
  title: Record<string, string>
  onClick: () => void
  isCursorDefault?: boolean
}

const DiscountButton: FC<Props> = ({title, onClick, isCursorDefault}) => {
  return (
    <div className='d-flex align-items-center gap-20'>
      <button
        id='btnAddDiscount'
        className={clsx(
          'btn btn-link p-0 py-2 text-primary-active fw-bolder ',
          isCursorDefault && 'cursor-default'
        )}
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        title={title.btn}
        data-bs-original-title='Coming soon'
        onClick={onClick}
      >
        {title.btn}
      </button>
      <span className='text-dark'>{title.name}</span>
    </div>
  )
}
export default DiscountButton
